import { Component, OnInit } from '@angular/core';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    imports: [MainLayoutComponent]
})
export class LayoutComponent implements OnInit {

  constructor() { } 

  ngOnInit(): void {
  }

}
